import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function LinkedinLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("LinkedInLogin mounted");

    const params = new URLSearchParams(window.location.search);

    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error");

    if (error || !code) {
      navigate("/login");
      return;
    }

    let email = "";
    try {
      const decoded = JSON.parse(atob(state));
      email = decoded.email || "";
    } catch {}

    fetch(
      "https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge/lm_login/api/linkedin/token",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: code,
          email: email,
        }),
      }
    )
      .then(res => res.json())
      .then(data => {
        if (data.status === "SUCCESS") {
          localStorage.setItem("token", data.token);
          navigate("/dashboard");
        } else {
          navigate("/login");
        }
      })
      .catch(() => navigate("/login"));

  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h3>Signing you in with LinkedIn…</h3>
    </div>
  );
}

export default LinkedinLogin;
